import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState, Status } from "@client/types";
import { confirmActiveAction, setActiveAction } from "../../actions";
import { localStateSelector } from "../../selectors";
import { type Forums } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    const getParentComment = () => {
      if (localState.activeAction?.target === "comment") {
        const comment = localState.comments.find((x) => x.ticketCommentId === localState.activeAction?.targetId);

        if (
          localState.activeAction?.type === "reply" ||
          (localState.activeAction?.type === "update" && comment?.parentTicketCommentId)
        )
          return comment;
      }
    };

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      canCancel: localState.activeAction?.target === "comment",
      comment:
        localState.activeAction?.target === "comment" && localState.activeAction?.type === "update"
          ? localState.comments.find((x) => x.ticketCommentId === localState.activeAction?.targetId)
          : undefined,
      isBusy: localState.status === Status.Saving,
      isCommentUpdate: localState.activeAction?.target === "comment" && localState.activeAction?.type === "update",
      parentComment: getParentComment(),
      resetKey: localState.comments.length.toString() // reset when a comment is added
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onCancel: () => dispatch(setActiveAction(getEntityRef(props), null)),
  onSubmit: (data: Forums.View.AddEditPostComment) => dispatch(confirmActiveAction({ ...getEntityRef(props), data }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps, { forwardRef: true })(Component);
